import { render, staticRenderFns } from "./MovableTextBoxInputMethodSelector.vue?vue&type=template&id=c86520ea&scoped=true&"
import script from "./MovableTextBoxInputMethodSelector.vue?vue&type=script&lang=ts&"
export * from "./MovableTextBoxInputMethodSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86520ea",
  null
  
)

export default component.exports